import React, { Component } from 'react'
import { Form, Input, AutoComplete, Button, Icon } from 'antd'
import InputMask from 'react-input-mask'
import { convertToOption } from '../util'

const FormItem = Form.Item
const propTypes = {}

class CreateContactForm extends Component {
  getSelectedOrganization = value => {
    const selectedOrganization = this.props.allOrganizations.find(
      organization => organization.name === value
    )
    return selectedOrganization ? +selectedOrganization.id : +value
  }

  handleCreateContact = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      // sanitize organization_id
      values.organization_id = this.getSelectedOrganization(values.organization_id)

      this.props.createContact({
        jobId: this.props.jobId,
        content: values,
        userId: this.props.user.userId
      })

      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { contentData, allOrganizations } = this.props
    return (
      <div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Company">
                {getFieldDecorator('organization_id', {
                  rules: [
                    {
                      required: true,
                      message: 'Choose a company'
                    }
                  ],
                  initialValue: contentData ? contentData.organization_id : ''
                })(
                  <AutoComplete
                    dataSource={convertToOption(allOrganizations)}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    style={{ width: 320 }}
                    placeholder="Search for a Company"
                    onBlur={this.props.handleBlurOrganization}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="First Name">
                {getFieldDecorator('first_name', {
                  rules: [
                    {
                      required: true,
                      message: 'First name cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.first_name : ''
                })(<Input placeholder="Type in a first name..." />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Last Name">
                {getFieldDecorator('last_name', {
                  rules: [
                    {
                      required: true,
                      message: 'Last name cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.last_name : ''
                })(<Input placeholder="Type in a last name..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Title">
                {getFieldDecorator('title', {
                  initialValue: contentData ? contentData.title : ''
                })(<Input placeholder="Type in the title..." />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Email">
                {getFieldDecorator('email', {
                  initialValue: contentData ? contentData.email : ''
                })(<Input placeholder="Type in email address..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Phone Number">
                {getFieldDecorator('phone_number', {
                  rules: [
                    {
                      required: true,
                      message: 'Phone number cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.phone_number : ''
                })(<InputMask className="ant-input" mask="(999) 999-9999 ext:9999" maskChar="_" />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Mobile Number">
                {getFieldDecorator('mobile_number', {
                  initialValue: contentData ? contentData.mobile_number : ''
                })(<InputMask className="ant-input" mask="(999) 999-9999 ext:9999" maskChar="_" />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Button onClick={() => this.handleCreateContact()} icon="save">
                Create Contact
              </Button>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

CreateContactForm.propTypes = propTypes
export default Form.create()(CreateContactForm)



// WEBPACK FOOTER //
// ./src/components/CreateContactForm.js